import { createContext, useContext } from 'react';
import cityExplorerService from '../../services/cityExplorerService';

/**
 * Where live maps get their data. Logged-in pages use the authenticated
 * cityExplorerService; SharedLocationExplorer provides the share link's
 * client (cityExplorerPublicShareService.liveDataClient) instead.
 */
const CityExplorerDataContext = createContext(cityExplorerService);

export const CityExplorerDataProvider = CityExplorerDataContext.Provider;

export function useCityExplorerData() {
  return useContext(CityExplorerDataContext);
}

/** Tab-level cache key for one client and location. */
export function dataCacheKey(client, locationId) {
  return `${client?.cacheKey || 'auth'}:${locationId}`;
}
